import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ChatContextProvider } from '../context/ChatContext';
import ProtectedRoute from './ProtectedRoute';
import { AuthProvider } from '../context/AuthContext';

const Unauthorized = lazy(() => import('../pages/Unauthorized'));
const ChatLogsPage = lazy(() => import('../pages/ChatLogsPage'));
const HomePage = lazy(() => import('../pages/HomePage'));

// const accessKey = sessionStorage.getItem('accessKey')

const AppRoutes = () => (
  <BrowserRouter>
    <AuthProvider>
      <Suspense fallback={<div>Loading...</div>}>
        <ChatContextProvider>
          <Routes>
            <Route path="/" element={<Unauthorized />} />
            <Route element={<ProtectedRoute />}>
              <Route path={`/home`} element={<HomePage />} />
              <Route path={`/chat`} element={<ChatLogsPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </ChatContextProvider>
      </Suspense>
    </AuthProvider>
  </BrowserRouter>
);

export default AppRoutes;